import { isEmpty } from 'lodash/fp';
import { useCallback } from 'react';
import VehiclePrefillForm, { VehiclePrefillFormProps } from '../components/VehiclePrefillForm';
import { EditSaleTransactionFormValues } from './EditSaleTransactionForm';
import EditSaleTransactionHeader from './EditSaleTransactionHeader';
import { Page, useEditSaleTransactionState } from './EditSalesTransactionStateProvider';

const EditVehiclePrefillForm = () => {
    const {
        state: { prefillRaw, formValues, initialValues },
        actions,
    } = useEditSaleTransactionState();

    const onComplete: VehiclePrefillFormProps<EditSaleTransactionFormValues>['onComplete'] = useCallback(
        ({ raw, updatedValues }) => {
            if (!isEmpty(updatedValues)) {
                actions.setFormValues(updatedValues);
                actions.setPrefillRaw(raw);
            }
            actions.setCurrentPage(Page.VehicleForm);
        },
        [actions]
    );

    return (
        <VehiclePrefillForm
            formValues={formValues}
            header={<EditSaleTransactionHeader currentPage={Page.VehiclePrefill} />}
            initialValues={initialValues}
            onComplete={onComplete}
            prefillRaw={prefillRaw}
        />
    );
};

export default EditVehiclePrefillForm;
